import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiClient from "../../api-client";
import { apiUrl, PORT } from "../../environment";
import { toasterConfig } from "../../utils/constants";
import Cookies from 'js-cookie';

toast.configure();

export const register = (data, callback) => {
  return (dispatch) => {
    ApiClient.post(`${apiUrl}${PORT}/register`, data).then((response) => {
      if (response.errors) {
        switch (response.errors.msg) {
          case "EMAIL_ALREADY_EXISTS":
            toast.dismiss();
            toast.error("This email id is already registered", toasterConfig);
            break;
        }
        return callback();
      } else if (response) {
        toast.dismiss();
        toast.success("Account has been created successful", toasterConfig);
        dispatch({ type: "REGISTER", data: response });
        localStorage.setItem("TOKEN", JSON.stringify(response.token));
        localStorage.setItem("LOGOUT", false);
        return callback(response);
      } else {
        toast.error(response.message);
        return callback();
      }
    });
  };
};

export const login = (data, callback) => {
  return (dispatch) => {
    ApiClient.post(`${apiUrl}${PORT}/login`, data).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      if (response && response.token) {
        toast.dismiss();
        toast.success("Login Successful", toasterConfig);
        dispatch({ type: "LOGIN", data: response });
        dispatch({ type: "SHOW_WELCOME_MESSAGE", payload: false });
        localStorage.setItem("TOKEN", JSON.stringify(response.token));
        localStorage.setItem("LOGOUT", false);
        dispatch({ type: "NOTIFICATION_ENABLE", data: true });
        return callback(response);
      } else if (response.messageID === 404) {
        toast.error(response.message, toasterConfig);
        return callback(response);
      } else {
        switch (response.errors.msg) {
          case "SUPER_ADMIN_NOT_FOUND":
            toast.dismiss();
            toast.error(
              "Invalid Credentials, Please try again.",
              toasterConfig
            );
            break;
          case "WRONG_PASSWORD":
            toast.dismiss();
            toast.error(
              "Invalid Credentials, Please try again.",
              toasterConfig
            );
            break;
          case "LOCATION_INACTIVE":
            toast.dismiss();
            toast.error(
              "WorkGroup Inactive, Please contact to admin",
              toasterConfig
            );
            break;
          case "USER_INACTIVE":
            toast.dismiss();
            toast.error(
              "User Inactive, Please contact to admin.",
              toasterConfig
            );
            break;
          case "ORGANIZATION_INACTIVE":
            toast.dismiss();
            toast.error(
              "Your Organization is deactived, Please contact admin.",
              toasterConfig
            );
            break;
          case "USER_DOES_NOT_EXIST":
            toast.dismiss();
            toast.error("Invalid Credentials, Please try again.");
            break;
        }
        return callback();
      }
    });
  };
};

/* // OLD LOGOUT FUNCTION
export const logout = (callback) => {
  return (dispatch) => {
    localStorage.removeItem("_expiredTime");
    localStorage.removeItem("TOKEN");
    localStorage.setItem("LOGOUT", true);
    dispatch({ type: "LOGOUT", data: {} });
    dispatch({ type: "SET_TEMPDATA", data: {} });
    toast.dismiss();
    toast.success("Logout Successful", toasterConfig);
    return callback();
  };
}; */

export const logout = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    let url = `${apiUrl}${PORT}/logout`;
    ApiClient.get(url, params, token, dispatch).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      localStorage.removeItem("_expiredTime");
      localStorage.removeItem("TOKEN");
      localStorage.setItem("LOGOUT", true);
      localStorage.clear();
      dispatch({ type: "LOGOUT", data: {} });
      dispatch({ type: "SET_TEMPDATA", data: {} });
      Cookies.remove("lastActive");
      if(caches){
        caches.keys().then((names) => {
          names.forEach((name) => {
            caches.delete(name);
          });
        });
      }
      toast.dismiss();
      // toast.success("Logout Successful", toasterConfig);
    });
  };
};

export const subadminLogout = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    let url = `${apiUrl}${PORT}/subadminLogout`;
    ApiClient.get(url, params, token, dispatch).then((response) => {
      console.log(response);
      localStorage.removeItem("_expiredTime");
      localStorage.removeItem("TOKEN");
      localStorage.setItem("LOGOUT", true);
      localStorage.clear();
      dispatch({ type: "LOGOUT", data: {} });
      dispatch({ type: "SET_TEMPDATA", data: {} });
      console.log('Callback start');
      callback(response);
    });
  };
};

export const subadminOrgLogout = (params, callback) => {
  return (dispatch, getState) => {
    // const {
    //   user: { token },
    // } = getState();
    console.log(params, "loginSubAdmin")
    let url = `${apiUrl}${PORT}/subadminLogout`;
    ApiClient.get(url, params, params?.token, dispatch).then((response) => {
      console.log(response);
      localStorage.removeItem("_expiredTime");
      localStorage.removeItem("TOKEN");
      localStorage.setItem("LOGOUT", true);
      localStorage.clear();
      dispatch({ type: "LOGOUT", data: {} });
      dispatch({ type: "SET_TEMPDATA", data: {} });
      console.log('Callback start');
      callback(response);
    });
  };
};

export const changePassword = (data, callback) => {
  return (dispatch) => {
    ApiClient.post(`${apiUrl}${PORT}/changePassword`, data).then((response) => {
      if (response.errors) {
        switch (response.errors.msg) {
          case "WRONG_PASSWORD":
            toast.dismiss();
            toast.error("Incorrect old password", toasterConfig);
          case "PASSWORD_ALREADY_USED":
            toast.dismiss();
            toast.error("You cannot reuse a password that was used recently. Please choose a new one.", toasterConfig)
            break;
            default:
              toast.dismiss();
              toast.error(response.errors.msg, toasterConfig)
        }
        return callback();
      } else if (response) {
        toast.success("Password has been changed successful", toasterConfig);
        return callback(response);
      } else {
        toast.error(response.message, toasterConfig);
        return callback();
      }
    });
  };
};

export const updateProfile = (data, callback) => {
  return (dispatch) => {
    dispatch({ type: "ISLOADING", data: true });
    ApiClient.post(`${apiUrl}${PORT}/users/updateProfile`, data).then(
      (response) => {
        dispatch({ type: "ISLOADING", data: false });
        if (response.errors) {
          toast.error(response.errors.msg, toasterConfig);

          return callback();
        } else if (response) {
          dispatch({ type: "UPDATE_PROFILE", data: response });
          toast.dismiss();
          toast.success("Profile updated successful", toasterConfig);

          return callback(response);
        } else {
          toast.error(response.message, toasterConfig);
          return callback();
        }
      }
    );
  };
};

/**
 * @description function use for to update user profile image
 * @param {*} params accepting object
 */
export const uploadProfileImage = (data, id, callback) => {
  return (dispatch, getState) => {
    dispatch({ type: "ISLOADING", data: true });
    const {
      user: { token },
    } = getState();
    ApiClient.putFormData(
      `${apiUrl}${PORT}/users/${id}`,
      data,
      token,
      dispatch
    ).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      if (response.errors) {
        toast.error(response.errors.msg, toasterConfig);
        return callback();
      } else if (response) {
        dispatch({ type: "UPDATE_PROFILE", data: response });
        toast.dismiss();
        toast.success(
          "Profile Image has been updated successful",
          toasterConfig
        );
        return callback(response);
      } else {
        toast.error(response.message);
        return callback();
      }
    });
  };
};

/**
 * @description function use for to update organization logo
 * @param {*} params accepting object
 */
export const uploadLogo = (data, id, callback) => {
  return (dispatch, getState) => {
    dispatch({ type: "ISLOADING", data: true });
    const {
      user: { token },
    } = getState();
    ApiClient.putFormData(
      `${apiUrl}${PORT}/users/uploadLogo/${id}`,
      data,
      token,
      dispatch
    ).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      if (response.errors) {
        toast.error(response.errors.msg, toasterConfig);
        return callback();
      } else if (response) {
        dispatch({ type: "UPDATE_LOGO", data: response });
        toast.dismiss();
        toast.success("Logo has been updated successful", toasterConfig);
        return callback(response);
      } else {
        toast.error(response.message);
        return callback();
      }
    });
  };
};

export const unauthorized = () => {
  return (dispatch) => {
    toast.error("Unauthorized Url", toasterConfig);
  };
};

/**
 * @description function use for to delete user profile image
 * @param {*} params accepting object
 */
export const deleteProfileImage = (callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.delete(
      `${apiUrl}${PORT}/users/deleteProfileImage`,
      token,
      dispatch
    ).then((response) => {
      if (response && !response.errors) {
        dispatch({ type: "UPDATE_PROFILE", data: response });
        toast.dismiss();
        toast.success(
          "Profile Image has been deleted successful",
          toasterConfig
        );
        callback(response);
      } else if (response.code === 404) {
        toast.warn(response.message);
      } else {
        toast.error(response.errors.msg, toasterConfig);
      }
    });
  };
};

/**
 * @description function use for to delete organization logo
 * @param {*} params accepting object
 */
export const deleteOrganizationLogo = (callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.delete(
      `${apiUrl}${PORT}/users/deleteOrganizationLogo`,
      token,
      dispatch
    ).then((response) => {
      if (response && !response.errors) {
        dispatch({ type: "UPDATE_LOGO", data: response });
        toast.dismiss();
        toast.success("Logo has been deleted successful", toasterConfig);
        callback(response);
      } else if (response.code === 404) {
        toast.warn(response.message);
      } else {
        toast.error(response.errors.msg, toasterConfig);
      }
    });
  };
};

/**
 * @description function use for to forgot password
 * @param {*} params accepting object
 */
export const forgotPassword = (data, callback) => {
  return (dispatch) => {
    dispatch({ type: "ISLOADING", data: true });
    ApiClient.post(`${apiUrl}${PORT}/forgotPassword`, data).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      if (response.errors) {
        switch (response.errors.msg) {
          case "USER_DOES_NOT_EXIST":
            toast.dismiss();
            toast.error("User Does Not Exist");
            break;
        }
        return callback();
      } else if (response) {
        toast.dismiss();
        toast.success(
          "Please check your email for password reset link.",
          toasterConfig
        );
        return callback(response);
      } else {
        toast.error(response.message);
        return callback();
      }
    });
  };
};

/**
 * @description function use for to forgot password
 * @param {*} params accepting object
 */
export const resetPassword = (data, callback) => {
  return (dispatch) => {
    dispatch({ type: "ISLOADING", data: true });
    ApiClient.post(`${apiUrl}${PORT}/resetPassword`, data).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      if (response.errors) {
        switch (response.errors.msg) {
          case "USER_DOES_NOT_EXIST":
            toast.dismiss();
            toast.error("User Does Not Exist", toasterConfig);
            break;
          case "PASSWORD_EXPIRE":
            toast.dismiss();
            toast.error(
              "Reset password time has been expired. Please try again",
              toasterConfig
            );
            break;
          case "PASSWORD_ALREADY_USED":
            toast.dismiss();
            toast.error("You cannot reuse a password that was used recently. Please choose a new one.", toasterConfig)
            break;
          default:
            toast.dismiss();
            toast.error(response.errors.msg, toasterConfig)
        }
        return callback();
      } else if (response) {
        toast.dismiss();
        toast.success("Password has been changed successful", toasterConfig);
        return callback(response);
      } else {
        toast.error(response.message);
        return callback();
      }
    });
  };
};

/**
 * @description function use for to forgot password
 * @param {*} params accepting object
 */
export const accountUpdate = (data, callback) => {
  return (dispatch) => {
    dispatch({ type: "ISLOADING", data: true });
    ApiClient.post(`${apiUrl}${PORT}/accountUpdate`, data).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      if (response.errors) {
        switch (response.errors.msg) {
          case "USER_DOES_NOT_EXIST":
            toast.dismiss();
            toast.error("Account Setup time has been expired", toasterConfig);
            break;
          case "ORGANIZATION_INACTIVE":
            toast.dismiss();
            toast.error("Organization is Inactive. Please Contact Admin", toasterConfig);
            break;
          case "PASSWORD_EXPIRE":
            toast.dismiss();
            toast.error(
              "Account Setup time has been expired. Please try again",
              toasterConfig
            );
            break;
        }
        return callback();
      } else if (response) {
        dispatch({ type: "LOGIN", data: response });
        dispatch({ type: "SHOW_WELCOME_MESSAGE", payload: true });
        localStorage.setItem("TOKEN", JSON.stringify(response.token));
        localStorage.setItem("LOGOUT", false);
        dispatch({ type: "NOTIFICATION_ENABLE", data: true });
        return callback(response);
      } else {
        toast.error(response.message);
        return callback();
      }
    });
  };
};

/**
 * @description function use for to forgot password
 * @param {*} params accepting object
 */
export const passwordExpired = (data, callback) => {
  return (dispatch) => {
    dispatch({ type: "ISLOADING", data: true });
    ApiClient.post(`${apiUrl}${PORT}/passwordExpired`, data).then(
      (response) => {
        dispatch({ type: "ISLOADING", data: false });
        if (response.errors) {
          // switch (response.errors.msg) {
          //   case "ALREADY_RESET":
          //     toast.dismiss();
          //     toast.error(
          //       "You have already reset your password",
          //       toasterConfig
          //     );
          //     break;
          //   case "PASSWORD EXPIRE":
          //     toast.dismiss();
          //     toast.error(
          //       "Reset password time has been expired. Please try again",
          //       toasterConfig
          //     );
          //     break;
          // }
          return callback(response);
        } else if (response) {
          return callback(response);
        } else {
          toast.error(response.message);
          return callback();
        }
      }
    );
  };
};

export const checkEmailLink = (id, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    dispatch({ type: "ISLOADING", data: true });
    let url = `${apiUrl}${PORT}/users/checkEmailLink/${id}`;
    ApiClient.get(url, {}, token, dispatch).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      // response = JSON.parse(response);
      if (response && !response.errors) {
        callback(response);
      } else if (response.code === 404) {
        callback(false)
        toast.warn(response.message);
      } else {
        callback(false)
      }
    });
  };
};

// export const saveTempData = (params, callback) => {
//   return (dispatch, getState) => {

//     const { user: { token } } = getState();

//     ApiClient.post(`${apiUrl}${PORT}/documents/saveTempData`, params, token, dispatch).then((response) => {
//       dispatch({ type: "ISLOADING", data: false });
//       toast.dismiss();
//       if (response && !response.errors) {

//         toast.success('Data saved in draft', toasterConfig);

//         callback(response);
//       } else {
//         // toast.error(response.errors.msg, toasterConfig);
//         return callback(response);
//       }
//     });
//   }
// };

export const updateTimezone = (data, callback) => {
  return (dispatch) => {
    dispatch({ type: "ISLOADING", data: true });
    ApiClient.post(`${apiUrl}${PORT}/users/updateTimezone`, data).then(
      (response) => {
        dispatch({ type: "ISLOADING", data: false });
        if (response.errors) {
          toast.error(response.errors.msg, toasterConfig);

          return callback();
        } else if (response) {
          dispatch({ type: "UPDATE_TIMEZONE", data: response });
          toast.dismiss();
          toast.success("Timezone updated successful", toasterConfig);

          return callback(response);
        } else {
          toast.error(response.message, toasterConfig);
          return callback();
        }
      }
    );
  };
};